import { Injectable } from '@angular/core';
import { PageEvent } from '@angular/material/paginator';
import { environment } from 'src/environments/environment';
// import {IResponseBody, IUserExportResponseBody} from '@interface/response-body';
import {
  IResponseBody,
  IUserExportResponseBody,
} from 'src/app/interfaces/response-body';
// import {User, UserEmployeeIds} from '@module/user/types/user';
import { ApiService } from 'src/app/services/api.service';
import { endpoints } from 'src/app/constants/endpoints';
import { CommonFunctionService } from 'src/app/services/common-function.service';
import { IGroup } from 'src/app/interfaces/group';

@Injectable()
export class UserApiService {
  constructor(
    protected Api: ApiService,
    protected commonFunctionService: CommonFunctionService
  ) {}
  userAdminApi = environment.userAdminUrl;

  //   public list(clubId: string) {
  //     let endpoint = `${environment.apiUrl}/user-admin/clubs/${clubId}`;

  //     return this.Api.get(endpoint)
  //       .then((data: any) => data)
  //       .catch(error => this.Api.handleError(error).then(() => Promise.reject()));
  //   }

  public exportList(role: string, endpointUrl: string, PageEvent?: PageEvent) {
    const endpointConfig = endpoints.user[endpointUrl];
    const url = this.commonFunctionService.findApiUrl(role);

    return this.Api.getWithPageEventFilter(
      `${role}/${endpointConfig}`,
      PageEvent,
      { type: 'all', searchString: null },
      url
    )
      .then((data: IUserExportResponseBody) => data)
      .catch((error) =>
        this.Api.handleError(error).then(() => Promise.reject())
      );
  }

  public listWithPageEvent(
    role: string,
    endpointUrl: string,
    filter?: {},
    PageEvent?: PageEvent
  ) {
    const endpointConfig = endpoints.user[endpointUrl];
    let endpoint = `${role}/${endpointConfig}`;
    const url = this.commonFunctionService.findApiUrl(role);

    return this.Api.getWithPageEventFilter(
      endpoint,
      PageEvent,
      filter,
      url
    ).then((ResponseBody: IResponseBody) => ResponseBody);
  }

  public getUser(userId, role) {
    const endpoint = `${role}/users/user/id/${userId}`;
    const url = this.commonFunctionService.findApiUrl(role);

    return this.Api.get(endpoint, url);
  }

  public update(User, role?: string) {
    const endpoint = `${role}/users`;
    const url = this.commonFunctionService.findApiUrl(role);

    return this.Api.put(endpoint, User, url).then((id) => {
      this.Api.handleSuccess(`User with id ${id.id} saved`);
      return id;
    });
  }

  public updatePassword(userId, role) {
    const endpoint = `${role}/users/generate-password`;
    const url = this.commonFunctionService.findApiUrl(role);

    return this.Api.put(endpoint, { userId: userId }, url).then((id) => {
      this.Api.handleSuccess(`New password set for user with id ${userId}`);
      return id;
    });
  }

  public reset(User, role) {
    const endpoint = `${role}/users/reset-password`;
    const url = this.commonFunctionService.findApiUrl(role);

    return this.Api.patch(endpoint, User, url)
      .then((id) => {
        this.Api.handleSuccess(`User with id ${id.id} has been updated`);
        return id;
      })
      .catch((error) =>
        this.Api.handleError(error).then(() => Promise.reject())
      );
  }

  public addUserToGroup(options, role?: string) {
    let endpoint = `${role}/user-group`;
    const url = this.commonFunctionService.findApiUrl(role);
    return this.Api.post(endpoint, options, url);
  }

  public getUserGroups(userId: number, filter?: {}, role?: string) {
    let endpoint = `${role}/groups/user-id/${userId}`;
    const url = this.commonFunctionService.findApiUrl(role);
    endpoint = this.commonFunctionService.addFilterToEndpointWithoutPagination(
      endpoint,
      filter
    );
    return this.Api.get(endpoint, url);
  }

  public getFilteredGroups(filter?: {}, role?: string) {
    let endpoint = `${role}/groups`;
    const url = this.commonFunctionService.findApiUrl(role);

    return this.Api.getWithoutPageEventFilter(endpoint, filter, url)
      .then((payload: { data: IGroup[] }) => payload)
      .catch((error) => this.Api.handleError(error));
  }

  public deleteGroup(groupId: number, userId: number, role?: string) {
    let endpoint = `${role}/user-group/${userId}/group-id/${groupId}`;
    const url = this.commonFunctionService.findApiUrl(role);

    return this.Api.delete(endpoint, url);
  }

  public getAddresses(role: string, userId: string) {
    let endpoint = `${role}/addresses/user-id/${userId}`;
    const url = this.commonFunctionService.findApiUrl(role);

    return this.Api.get(endpoint, url);
  }

  public deleteAddress(role: string, userId: string, addressId) {
    let endpoint = `${role}/addresses/${userId}/address-id/${addressId}`;
    const url = this.commonFunctionService.findApiUrl(role);

    return this.Api.delete(endpoint, url);
  }
}
